import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ASSET_IMAGE_WORKING_CLASS_NAME = 'AssetImageWorking';
export const ASSET_IMAGE_WORKING_CLASS_SLOTS = [
	'root',
	'progress',
	'primary',
] as const;

export type AssetImageWorkingClassSlot =
	(typeof ASSET_IMAGE_WORKING_CLASS_SLOTS)[number];

export interface AssetImageWorkingClasses {
	root: string;
	progress: string;
	primary: string;
}

export type AssetImageWorkingClassKey = keyof AssetImageWorkingClasses;

export const getAssetImageWorkingUtilityClass = (slot: string) =>
	generateUtilityClass(ASSET_IMAGE_WORKING_CLASS_NAME, slot);

export const assetImageWorkingClasses: AssetImageWorkingClasses =
	generateUtilityClasses(ASSET_IMAGE_WORKING_CLASS_NAME, [
		'root',
		'progress',
		'primary',
	]);

export default assetImageWorkingClasses;
